import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './common/Common.css';
import {Shell} from './shell/Shell';

ReactDOM.render(
  <React.StrictMode>
    <Shell />
  </React.StrictMode>,
  document.getElementById('root')
);
